import * as React from 'react'
import { AdvancedAlertModalSvg } from './AdvancedAlertModalSvg/AdvancedAlertModalSvg'
import ModalHeader from '@mulesoft/anypoint-components/lib/ModalHeader'
import ModalFooter from '@mulesoft/anypoint-components/lib/ModalFooter'
import ModalBody from '@mulesoft/anypoint-components/lib/ModalBody'
import Button from '@mulesoft/anypoint-components/lib/Button'
import Modal from '@mulesoft/anypoint-components/lib/Modal'
import './AdvancedAlertModal.css'

export type ValueProps = {
  isAdvancedAlertModalOpened: boolean
}

export type EventProps = {
  handleClose: () => void
}

export type Props = ValueProps & EventProps

export default class AdvancedAlertModal extends React.Component<Props> {
  
  componentDidMount() {
    this.props.handleClose()
  }
  
  render() {
    if (this.props.isAdvancedAlertModalOpened) {
      return (
        <Modal
          testId={'alert-modal'}
          onEsc={this.props.handleClose}
          onClickOverlay={this.props.handleClose}
        >
          <ModalHeader onClose={this.props.handleClose} testId={'alert-modal-header'}>
            <h1>How to setup an advanced alert</h1>
          </ModalHeader>
          <ModalBody testId={'alert-modal-body'}>
            <div className={'alert-modal-image'} data-test-id="alert-modal-image">
              <AdvancedAlertModalSvg/>
            </div>
            <div className={'alert-modal-description alert-modal-first-description'} data-test-id="alert-modal-first-description">
              Alerts are added and configured in the Alert Tab of any graph within Custom dashboards,
              letting you build and visualize an alert using existing queries.
            </div>
            <div className={'alert-modal-description'} data-test-id="alert-modal-second-description">
              To persist your alert rule changes remember to save the dashboard.
            </div>
          </ModalBody>
          <ModalFooter testId={'alert-modal-footer'}>
            <Button kind="tertiary" onClick={this.props.handleClose} noFill={true} testId={'alert-modal-done-button'}>Done</Button>
          </ModalFooter>
        </Modal>
      )
    }
    
    return null
  }
  
}
